export default "__VITE_ASSET__e4362060__"